<template>
  <div class="bottom">
    <div class="bt-main container">
      <div class="top">
        <div class="logo">
          <img src="@/assets/img/bottom-logo.png" alt="" class="logo" />
          <div class="logo-name">
            <p>Copyright 2024</p>
            <p>All rights reserved Blue Ridge Microfinance Bank Ltd.</p>
          </div>
        </div>
        <div class="jump"> 
          <router-link class="doc-link" to="/terms">Terms of Service</router-link>
          <router-link class="doc-link" to="/privacy">Privacy Policy</router-link>
        </div>
        <div class="img-list">
          <img src="@/assets/img/bottom-icon1.png" alt="" @click="toFB" />
          <img src="@/assets/img/bottom-icon2.png" alt="" />
          <img src="@/assets/img/bottom-icon3.png" alt="" />
        </div>
      </div>
      <div class="bot">
        <div class="ok common" @click="toOK">
          <img class="logo" src="@/assets/img/OK.png" alt="" />
          <span>OKash</span>
          <img class="google_play" src="@/assets/img/google_play.png" alt="">
        </div>
        <div class="em common" @click="toEM">
          <img class="logo" src="@/assets/img/EM.png" alt="" />
          <span>EaseMoni</span>
          <img class="google_play" src="@/assets/img/google_play.png" alt="">
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  methods: {
    toOK() {
      window.location.href = 'https://okash.onelink.me/rWwB/gi1tphhu'
    },
    toEM() {
      window.location.href = 'https://myem.onelink.me/qpgB/aan3leel'
    },
    toFB() {
      window.location.href = 'https://u.o-kash.com/A0at'
    }
  },
}
</script>
<style scoped lang="scss">
@import '@/styles/public.scss';
.bottom {
  background-color: #111111;
  padding: 53px 120px 54px;
  .bt-main {
    .top {
      height: 54px;
      @include flex-base;
      .logo {
        @include flex-base;
        img {
          width: 120px;
          margin-right: 24px;
        }
        .logo-name p {
          color: #fff;
          font-size: 12px;
          &:last-child {
            margin-top: 11px;
          }
        }
      }
      .jump {
        height: 54px;
        @include flex-base;
        a {
          color: #ffffff;
          font-size: 16px;
          font-weight: 700;
          text-decoration-line: underline;
          &:last-child {
            margin-left: 19px;
          }
        }
      }
      .img-list {
        height: 54px;
        @include flex-base;
        img {
          width: 40px;
          height: 40px;
          margin-right: 16px;
          cursor: pointer;
          &:last-child {
            margin: 0;
          }
        }
      }
    }
    .bot {
      display: flex;
      align-items: center;
      margin-top: 43px;
      height: 44px;
      .common {
        height: 44px;
        display: flex;
        align-items: center;
        &:last-child {
          margin-left: 115px;
        }
        .logo {
          width: 44px;
          height: 44px;
        }
        span {
          color: #fff;
          font-size: 16px;
          font-weight: 600;
          margin: 0 59px 0 20px;
        }
        .google_play {
          width: 137px;
          height: 40px;
          cursor: pointer;
        }
      }
    }
  }
}
</style>
